import React from 'react';
import { t, Trans } from '@lingui/macro';
import Collapse from '@mos-front-components/public/es/components/Collapse/Collapse';

import Link from '../../shared/Link/Link';
import './InfoAboutService.pcss';
import { i18n } from '../../../helpers/i18n';
import { aboutServiceCollapsible } from '../../../constants/iterableTexts';

const { Panel } = Collapse;

function InfoAboutService(): JSX.Element {
  const collapseContent = aboutServiceCollapsible.map(
    ({ title, text }, index) => {
      return (
        <Panel key={index} header={title}>
          {text}
        </Panel>
      );
    }
  );
  return (
    <div className="InfoAboutService">
      <div className="InfoAboutService__title">
        <Trans>Информация по услуге</Trans>
      </div>
      <div className="InfoAboutService__row">
        <div className="InfoAboutService-block col-md-8">
          <div className="InfoAboutService-block__title">
            <Trans>
              Присвоение (продление) льготного статуса многодетной семьи города
              Москвы
            </Trans>
          </div>
          <p className="InfoAboutService-step__text">
            <Trans>
              Данная услуга позволяет подать заявление на присвоение или
              продление статуса многодетной семьи города Москвы в электронном
              виде. Заявление может подать любой из родителей, проживающих
              совместно с детьми, при условии наличия места жительства в городе
              Москве (у родителей и детей).
            </Trans>
          </p>
          <div className="InfoAboutService-step__text">
            <Collapse>{collapseContent}</Collapse>
          </div>
          <div className="InfoAboutService-step__text">
            <Trans>
              Остались вопросы? Посмотрите{' '}
              <Link
                target="_blank"
                rel="noopener noreferrer"
                href={i18n._(t`/pgu/ru/faq/?service=1800`)}
              >
                часто задаваемые вопросы
              </Link>{' '}
              по этой услуге
            </Trans>
          </div>
        </div>
        <div className="InfoAboutService-block col-md-4">
          <div className="InfoAboutService-block__title">
            <Trans>Ведомство</Trans>
          </div>
          <div className="InfoAboutService-block__text">
            <Link
              href={i18n._(t`/dszn/`)}
              className="InfoAboutService-step__link"
              target="_blank"
            >
              <Trans>
                Департамент труда и социальной защиты населения города Москвы
              </Trans>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InfoAboutService;
